<template>
  <div class="sidebar-wedget-wrap">
    <div class="sidebar-wedget">
      <span class="top-title">بحث في المقالات</span>
      <form class="search-form position-relative z-1">
        <input type="text" class="form-control" placeholder="ابحث هنا..." />
        <button
          class="src-btn position-absolute top-50 end-0 translate-middle-y"
        >
          <i class="ri-search-line"></i>
        </button>
      </form>
    </div>

    <div class="sidebar-wedget">
      <span class="top-title">التصنيفات</span>
      <ul class="ps-0 mb-0 list-unstyled categories">
        <li>
          <RouterLink
            to="/categories"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <i class="ri-arrow-right-s-fill"></i>
              <span class="name">تلفزيون الستلايت</span>
            </div>
            <span class="count">(11)</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/categories"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <i class="ri-arrow-right-s-fill"></i>
              <span class="name">تكنولوجيا البث</span>
            </div>
            <span class="count">(09)</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/categories"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <i class="ri-arrow-right-s-fill"></i>
              <span class="name">حلول مشاكل الشبكة</span>
            </div>
            <span class="count">(14)</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/categories"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <i class="ri-arrow-right-s-fill"></i>
              <span class="name">حماية اشتراكات IPTV</span>
            </div>
            <span class="count">(15)</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/categories"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <i class="ri-arrow-right-s-fill"></i>
              <span class="name">الأعمال والتجارة</span>
            </div>
            <span class="count">(03)</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/categories"
            class="d-flex justify-content-between align-items-center"
          >
            <div class="d-flex align-items-center">
              <i class="ri-arrow-right-s-fill"></i>
              <span class="name">البث المباشر (Streaming)</span>
            </div>
            <span class="count">(24)</span>
          </RouterLink>
        </li>
      </ul>
    </div>

    <div class="sidebar-wedget">
      <span class="top-title">المقالات الشائعة</span>
      <ul class="ps-0 mb-0 list-unstyled popular-post">
        <li>
          <RouterLink to="/product-details" class="d-flex align-items-center">
            <div class="flex-shrink-0">
              <img src="@/assets/images/product-10.jpg" alt="blog" />
            </div>
            <div class="flex-grow-1 ms-3">
              <h4>أفضل أجهزة التوجيه (Router) لتشغيل سيرفرات IPTV بدون تقطيع</h4>
              <span class="text-body">25.00 €</span>
            </div>
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/product-details" class="d-flex align-items-center">
            <div class="flex-shrink-0">
              <img src="@/assets/images/product-11.jpg" alt="blog" />
            </div>
            <div class="flex-grow-1 ms-3">
              <h4>كيفية إعداد وتشغيل الاشتراكات على الشاشات الذكية (Smart TV)</h4>
              <span class="text-body">10.00 €</span>
            </div>
          </RouterLink>
        </li>
        <li>
          <RouterLink to="/product-details" class="d-flex align-items-center">
            <div class="flex-shrink-0">
              <img src="@/assets/images/product-12.jpg" alt="blog" />
            </div>
            <div class="flex-grow-1 ms-3">
              <h4>أهم 10 نصائح لتسريع جودة البث المباشر للمباريات الكبرى</h4>
              <span class="text-body">24 يناير، 2026</span>
            </div>
          </RouterLink>
        </li>
      </ul>
    </div>

    <div class="sidebar-wedget">
      <span class="top-title">الوسوم الشائعة</span>
      <ul class="ps-0 mb-0 list-unstyled popular-tags d-flex flex-wrap gap-2">
        <li>
          <RouterLink to="/tags">أعمال</RouterLink>
        </li>
        <li>
          <RouterLink to="/tags">تطبيقات</RouterLink>
        </li>
        <li>
          <RouterLink to="/tags">سيرفرات</RouterLink>
        </li>
        <li>
          <RouterLink to="/tags">حماية الشبكة</RouterLink>
        </li>
        <li>
          <RouterLink to="/tags">إنترنت سريع</RouterLink>
        </li>
        <li>
          <RouterLink to="/tags">شاشات ذكية</RouterLink>
        </li>
        <li>
          <RouterLink to="/tags">نصائح البث</RouterLink>
        </li>
        <li>
          <RouterLink to="/tags">بث مباشر</RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SidebarWidget",
});
</script>